import Text from './Text';
import { TextColourEnum, TextCombinedProps, TextProps, TextValueProps } from './types';

export type { TextProps, TextColourEnum, TextValueProps, TextCombinedProps };
export default Text;
